import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { Helmet } from "react-helmet"
import { StaticImage } from "gatsby-plugin-image"

const JobsPage = ({ data }) => {
  const page = data?.allWpPage?.nodes?.[0]

  return (
    <Layout>
      <Seo title={page?.seo?.title || page?.title} description={page?.seo?.metaDesc} />
        <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0"
        />
      </Helmet>
  
        <section className="header_section">
          <div className="container">
            <div className="header_section__content">
              <h1>Jobs</h1>
              <div className="header_section__content_sub">
                <div>The Expert Recruiters in Medical Aesthetics </div>
              </div>
             <div className="header_section__content_btn text-center">
                <a href="#content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="bounce"
                    width="109.491"
                    height="57.574"
                    viewBox="0 0 109.491 57.574"
                  >
                    <path
                      id="Path_5"
                      data-name="Path 5"
                      d="M-847.3,2972.583h0l53.331,53.331-53.331,53.332"
                      transform="translate(3080.66 848.711) rotate(90)"
                      fill="none"
                      stroke="rgba(53,51,67,0.5)"
                      strokeWidth="4"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div className="header_section__image">
              <div className="header-container--standars">
                <StaticImage
                  src="../../static/assets/images/header/image_1.svg"
                  placeholder="blurred"
                  alt="Arc aesthetics"
                />
              </div>
            </div>
          </div>
          <div className="standard_header_path">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              viewBox="0 0 1924.003 706.339"
            >
              <path
                id="Path_1"
                data-name="Path 1"
                d="M.5,1210.979h1924V504.64S1271.73,915.921,929.1,801.894.5,1037.8.5,1037.8Z"
                transform="translate(-0.5 -504.64)"
                fill="#ecebe4"
              />
            </svg>
          </div>
        </section>


      <section className="intro_text">
        <div className="container" id="content">
          <div className="section__title text-center">Jobs in Aesthetics</div>
<div className="intro_text__holder">
          <div
            dangerouslySetInnerHTML={{
              __html: page?.content || "",
            }}
          />
        </div>
            </div>
      </section>
    </Layout>
  )
}

export default JobsPage

export const pageQuery = graphql`
  query JobPage {
    allWpPage(filter: { uri: { eq: "/jobs/" } }) {
      nodes {
        uri
        slug
        title
        content
        seo {
          title
          metaDesc
        }
      }
    }
  }
`
